import React, { Component } from 'react';
import { FormGroup, FormControl, Modal } from 'react-bootstrap';
import { getFormFieldSize } from '../../utils/Resources';
import LoaderButton from '../LoaderButton';

export default class EditItemModal extends Component {
  constructor(props) {
    super(props);
    let solutionNames = [];
    if (props.itemType === 'problem' && props.solutionNames && props.solutionNames.length > 0) {
      props.solutionNames.forEach((solutionName) => {
        solutionNames.push(solutionName);
      });
    } else {
      solutionNames = [''];
    }
    this.state = {
      name: props.name,
      solutionNames,
      isSaving: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { itemType, name, solutionNames } = this.props;
    if (prevProps.name !== name) {
      let updatedSolutionNames = [];
      if (itemType === 'problem' && solutionNames && solutionNames.length > 0) {
        solutionNames.forEach((solutionName) => {
          updatedSolutionNames.push(solutionName);
        });
      } else {
        updatedSolutionNames = [''];
      }
      this.setState({
        name,
        solutionNames: updatedSolutionNames,
      });
    }
  }

  handleChange = (event) => {
    if (event.target.value.length <= 35) {
      this.setState({ name: event.target.value });
    }
  }

  handleSolutionChange = (event, index) => {
    if (event.target.value.length <= 35) {
      const { solutionNames } = this.state;
      solutionNames.splice(index, 1, event.target.value);
      this.setState({ solutionNames });
    }
  }

  addSolutionInput = () => {
    this.setState((prevState) => ({ solutionNames: prevState.solutionNames.concat(['']) }));
  }

  removeSolutionInput = (index) => {
    const { solutionNames } = this.state;
    solutionNames.splice(index, 1);
    this.setState({ solutionNames });
  }

  validateForm = () => {
    const { itemType, name: originalName, solutionNames: originalSolutionNames } = this.props;
    const { name, solutionNames } = this.state;
    if (name.length === 0) {
      return false;
    }
    if (name !== originalName) {
      return true;
    }
    if (itemType === 'problem') {
      if (originalSolutionNames.length === 0 && solutionNames.length === 1 && solutionNames[0] === '') {
        return false;
      }
      if (solutionNames.length !== originalSolutionNames.length) {
        return true;
      }
      for (let i = 0; i < solutionNames.length; i += 1) {
        if (solutionNames[i] !== originalSolutionNames[i]) {
          return true;
        }
      }
    }
    return false;
  }

  updateItem = async (event) => {
    event.preventDefault();
    this.setState({ isSaving: true });
    const { updateItemName, hide } = this.props;
    const { name, solutionNames } = this.state;
    await updateItemName(name, solutionNames);
    this.setState({ isSaving: false });
    hide();
  }

  render() {
    const { show, hide, itemType } = this.props;
    const { name, solutionNames, isSaving } = this.state;
    const bsSize = getFormFieldSize();
    return (
      <Modal show={show} onHide={hide}>
        <Modal.Header closeButton>
          <Modal.Title>{`Edit ${itemType}:`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.updateItem}>
            <FormGroup controlId="itemName" bsSize={bsSize}>
              <FormControl
                autoFocus
                type="text"
                value={name}
                onChange={this.handleChange}
              />
            </FormGroup>
            {itemType === 'problem' && (
              <div>
                <h4 className="add-solution">Edit solutions:</h4>
                {solutionNames.map((solutionName, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={index} className="custom-solution">
                    <FormGroup controlId="solutionName" bsSize={bsSize} className="custom-solution-input">
                      <FormControl
                        type="text"
                        value={solutionName}
                        onChange={(event) => this.handleSolutionChange(event, index)}
                      />
                    </FormGroup>
                    <span className="delete-custom-solution">
                      <i className="fas fa-trash" onClick={() => this.removeSolutionInput(index)} />
                    </span>
                  </div>
                ))}
                <div className="add-another-solution" onClick={this.addSolutionInput}>
                  <i className="fas fa-plus" />
                  Add another solution
                </div>
              </div>
            )}
            <div className="save-custom-container">
              <LoaderButton
                className="save-custom-button"
                block
                bsSize={bsSize}
                disabled={!this.validateForm()}
                type="submit"
                text="Save"
                loadingText="Saving..."
                isLoading={isSaving}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}
